import React from 'react'

import * as S from './styles';

/**
 * 
 * @param {Array<{title: string, menuId: string, active: boolean}>} - An array of compoents to be rendered by each cell
 * @typedef {title} - Title to be rendered on the tab cell
 * @typedef {menuId} - left menu item id, so the menu item changes when the user clicks the tab item - the menu item item is the menu item name (e.g: menu item Carteirinha has id 'Carteirinha')
 * @typedef {active} - If the component is active
 * @returns - tab compoent
 * THIS IS NOT AM USUAL TAB COMPONENT, IT`S MADE TO WORK WITH THE LEFT MENU AND CHANGE ITS STATE, AS WELL AS THE RENDERED PAGE, WHEN THE USER CLICKS ON A TAB CELL
 * THIS TAB COMPONENT SIMULATES A CLICK ON A LEFT MENU`S ITEM, WHICH WILL THEN REDIRECT THE USER TO THE ACTUAL PAGE
 */
function TabMenu({ components }) {

    function handleClick(leftMenuId) {
        document.getElementById(leftMenuId).click()
    }

    return (
        <S.Row>
            {components.map(component =>
                <S.Tab key={component.id} active ={component.active} onClick={() => handleClick(component.menuId)}>{component.title}</S.Tab>
            )}
        </S.Row>
    );
}

export default TabMenu;
